import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

// TODO : this is now how we lazy load components. We should load at the route level once.

const ServiceForm = lazy(() => import('@app/features/services/components/ServiceForm/ServiceForm'));
const EditService = lazy(() => import('@pages/services/EditServicePage').then((m) => ({ default: m.EditService })));
const ServicesListPage = lazy(() => import('@pages/services/ServicesPage'));

// Route Components
const ServiceTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('services-page-title')}>
        <ServicesListPage />
      </PageWrapper>
    </Suspense>
  );
};

const ServiceFormPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('services-create-page-title')}>
        <ServiceForm />
      </PageWrapper>
    </Suspense>
  );
};

const ServiceEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('services-edit-page-title')}>
        <EditService />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  ServiceFormPage,
  ServiceTablePage,
  ServiceEditPage,
};
